import { createApp } from 'vue'
import App from './App.vue'
import mdiVue from 'mdi-vue/v3'
import * as mdijs from '@mdi/js'
import GamificationHub from "./plugins/SignalRPlugin/GamificationHub";

const app = createApp(App);

app.config.globalProperties.$filters = {
  formatDate(value) {
    const d = new Date(value);
    return d.toLocaleString();
  }
}
app.use(GamificationHub);

app.use(mdiVue, {
  icons: mdijs
}).mount('#app')
